<template>
  <div class="images-view">
    <div class="row">
      <div class="col-md-12">
        <file-uploader :accept="fileUploaderAccept" ref="imageUploader" :items-prop="images"
                       :in-progress="inProgress" @onItemRemove="onItemRemove" :base64-upload-mode="true"/>
      </div>
    </div>
  </div>
</template>

<script>
  import {createNamespacedHelpers} from "vuex";
  import FileUploader from "@/core/components/file-uploader/FileUploader";
  import {uuid} from "vue-uuid";

  const {mapState: mapStateGlobal} = createNamespacedHelpers('global');


  export default {
    name: "TemporaryImagesView",
    components: {FileUploader},
    props: {
      images: {
        type: Array,
        required: false,
      },
      changePermission: {
        type: [Boolean, String],
        default: false
      },
      source: {
        type: String,
        required: false
      }
    },
    data: () => {
      return {
        inProgress: false,
      };
    },
    computed: {
      ...mapStateGlobal(['videoFileFormats', 'videoMaxFileSize', 'imageFileFormats', 'imageMaxFileSize']),
      fileUploaderAccept() {
        return [
          {formats: this.videoFileFormats, maxSize: this.videoMaxFileSize},
          {formats: this.imageFileFormats, maxSize: this.imageMaxFileSize},
        ]
      }
    },
    methods: {
      setInitialItemIndex() {
        this.$refs.imageUploader.activeItemIndex = 0;
      },
      onItemRemove(index, deleteAll) {
        this.$emit('onImageRemove', index, deleteAll);
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
